import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormErrors} from '../common';
import SubscriptionForm from './SubscriptionForm';
import {createSubscription, createSubscriptionWithReader} from 'api';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import {Button, Step, StepContent, StepLabel, Stepper} from '@material-ui/core';

class SubscriptionCreation extends React.Component {
  static propTypes = {
    schoolId: PropTypes.number,
    classroomId: PropTypes.number,
    onSubmitSuccess: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      subscriptionType: null,
      errors: {},
    };
    this.selectSubscriptionType = this.selectSubscriptionType.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  selectSubscriptionType(subscriptionType) {
    this.setState({
      activeStep: 1,
      subscriptionType,
    });
  }

  previousStep() {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep - 1,
      subscriptionType: null,
    }));
  }

  handleFormSubmit(data) {
    const {subscriptionType} = this.state;
    const {classroomId, formatErrors, addFlashMessage, onSubmitSuccess} = this.props;
    data = {
      ...data,
      classroomId: classroomId ? classroomId : data.classroom.id,
    };
    let apiCall;
    if (subscriptionType === 'noEmail') {
      apiCall = () => createSubscriptionWithReader(data);
    } else {
      apiCall = () =>
        createSubscription({
          ...data,
          subscriptionType,
        });
    }
    return apiCall()
      .then(() => {
        addFlashMessage('Subscription has been successfully created!', 'success');
        onSubmitSuccess();
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {activeStep, subscriptionType, errors} = this.state;
    const {schoolId, classroomId} = this.props;
    return (
      <Stepper activeStep={activeStep} orientation="vertical">
        <Step>
          <StepLabel>Select Subscription Type</StepLabel>
          <StepContent>
            {/*<Button*/}
            {/*  variant="contained"*/}
            {/*  color="primary"*/}
            {/*  className="small-margin-around"*/}
            {/*  onClick={() => this.selectSubscriptionType('parentEmail')}*/}
            {/*>*/}
            {/*  Create Subscription Using Parent Email*/}
            {/*</Button>*/}
            {/*<br />*/}
            <Button
              variant="contained"
              color="primary"
              className="small-margin-around"
              onClick={() => this.selectSubscriptionType('readerEmail')}
            >
              Create Subscription Using Student Email
            </Button>
            <br />
            <Button
              variant="contained"
              color="primary"
              className="small-margin-around"
              onClick={() => this.selectSubscriptionType('noEmail')}
            >
              Create Subscription with no email
            </Button>
          </StepContent>
        </Step>
        <Step>
          <StepLabel>Create Subscription</StepLabel>
          <StepContent>
            <Button variant="contained" className="small-margin-around" onClick={this.previousStep}>
              Back
            </Button>
            <FormErrors errors={errors} />
            <SubscriptionForm.Creation
              noEmail={subscriptionType === 'noEmail'}
              schoolId={schoolId}
              classroomId={classroomId}
              onSubmit={this.handleFormSubmit}
            />
          </StepContent>
        </Step>
      </Stepper>
    );
  }
}

export default connect(null, {
  formatErrors,
  addFlashMessage,
})(SubscriptionCreation);
